module.exports = __webpack_public_path__ + "img/PropietarioDatos.cedcc302.svg";